<script setup lang="ts">
  defineProps<{
    prefix?: string;
    documentName?: string;
    revision?: number;
  }>();
</script>

<template>
  <div class="grid grid-cols-[1fr_3fr_auto] gap-4 p-6">
    <div class="flex flex-col gap-2">
      <span class="text-sm font-semibold text-gray-07">Prefixo</span>
      <input
        type="text"
        :value="prefix"
        disabled
        class="w-full px-4 py-2.5 border border-gray-02 rounded-lg text-gray-07 text-sm bg-gray-02 cursor-not-allowed"
      >
    </div>
    <div class="flex flex-col gap-2">
      <span class="text-sm font-semibold text-gray-07">Título</span>
      <input
        type="text"
        :value="documentName"
        disabled
        class="w-full px-4 py-2.5 border border-gray-02 rounded-lg text-gray-07 text-sm bg-gray-02 cursor-not-allowed"
      >
    </div>
    <div class="flex flex-col gap-2">
      <span class="text-sm font-semibold text-gray-07">Rev.</span>
      <input
        type="text"
        :value="revision != null ? String(revision).padStart(2, '0') : ''"
        disabled
        class="w-20 px-4 py-2.5 border border-gray-02 rounded-lg text-gray-07 text-sm bg-gray-02 cursor-not-allowed text-center"
      >
    </div>
  </div>
</template>
